module.exports = __webpack_public_path__ + "img/adv-bg.df980488.png";